import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  permissionKey: string;
  children: React.ReactElement;
}

const PermissionRoute: React.FC<Props> = ({ permissionKey, children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'superadmin' || user.role === 'admin') return children;
  const permissions = (user as any)?.permissions;
  if (!permissions || permissions[permissionKey] !== true) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PermissionRoute;
